import { Record } from 'immutable';
import { WallPaperPanelType } from '../interfaces/Wallpaper';

export const initialState: WallPaperPanelType = {
  isEnabled: false,
  imagePreviewURL: '',
  hasTypeError: false,
  hasDimensionsError: false,
  hasSizeError: false,
  filename: '',
  md5Sum: '',
};

export default class WallPaperPanelState extends Record(initialState) {
}
